import { useState } from "react";
import { buildApiHeaders, buildApiUrl, getQueryBootstrap } from "../../utils/apiBootstrap";

const useSpeechToText = ({ text, setText }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const uploadWavFile = async (file) => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      const { apiBaseUrl, chatId } = getQueryBootstrap();
      formData.append("chatId", chatId);
      formData.append("file", file);

      const response = await fetch(buildApiUrl(apiBaseUrl, "/stt"), {
        method: "POST",
        body: formData,
        headers: buildApiHeaders({
          "X-File-Type": "wav",
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setText(result.text); // Update recognizedText here
      } else {
        setError(result.error || "Unknown error occurred");
      }
    } catch (err) {
      setError("Error uploading file");
    } finally {
      setLoading(false);
    }
  };

  // Adding useEffect to track recognizedText changes

  return { error, loading, uploadWavFile };
};

export default useSpeechToText;
